/**
 * DatePicker
 * zeigt zwei Monate zur Datumsauswahl als Overlay an.
 * Verwendet in HXFormFieldDate HXFormFieldDateTime
 */
class HXFormFieldDatePicker{

    /**
     * @param {string} fieldname
     * @param {string} formName
     * @param {string} formVarsdict
     * @param {string} formFieldType
     */
    static init(fieldname, formName,formVarsdict, formFieldType){
        // DatePicker erstellen

        // Schliessen wenn man wieder aufs "Oeffnensymbol" klickt
        if(this.fieldname == fieldname){
            this.close();
            return;
        }

        this.aktCal = undefined;
        this.hxformfield = null;
        this.fieldname = fieldname;

        if (formFieldType==="HXFormFieldDate"){
            this.hxformfield = new HXFormFieldDate(fieldname,formName);
        }else if (formFieldType==="HXFormFieldDateTime"){
            this.hxformfield = new HXFormFieldDateTime(fieldname,formName);
        }

        if(!document.getElementById("calendar_" + fieldname)){
            var tempNode = document.createElement("div");
            var tempClass = document.createAttribute("class");
            tempClass.nodeValue = "datePicker";
            tempNode.style.visibility = 'visible';
            var tempId = document.createAttribute("id");
            tempId.nodeValue = "calendar_" + fieldname;
            var tempTabIdx = document.createAttribute("tabindex");
            tempTabIdx.nodeValue = this.hxformfield.getFieldObj().getAttribute("tabindex");
            tempNode.setAttributeNode(tempClass);
            tempNode.setAttributeNode(tempId);
            tempNode.setAttributeNode(tempTabIdx);
            document.body.appendChild(tempNode);
        }

        //dict-Texte fuer Uebergabe zusammensammeln
        var dict = [];
        for(let n = 1; n <= 12; n++) dict.push(formVarsdict["dictMonat"+n]);
        for(let n = 1; n <= 7; n++) dict.push(hx.substr(formVarsdict["dictWochentag"+n],0,2));
        dict.push(formVarsdict["dictKw"]);

        this.formFieldType = formFieldType;
        this.root = formVarsdict.root;

        this.dict = dict;
        // Aktuellen Kalender schliessen wenn ein anderer geoeffnet wird
        if(this.aktCal != undefined){
            this.close();
        }

        // Datum in Formfield formatieren
        this.chosen = this.getChosenDate();
        //if(this.chosen != null) this.dateInsert(fieldname, this.chosen.getFullYear(), this.chosen.getMonth(), this.chosen.getDate(), 0, 0);

        // Wenn geblaettert wird
        if(this.chosen){
            this.aktMonat = this.chosen.getMonth();
            this.aktJahr = this.chosen.getFullYear();
            // Wenn Kalender neu geoeffnet wird
        }else{
            this.aktMonat = new Date().getMonth();
            this.aktJahr = new Date().getFullYear();
        }
        this.show(this.fieldname);

        var t = hx.objByCssSelector("#calendar_" + this.fieldname + " .datePicker_month_container1 .datePicker_day_chosen")[0];
        if(t) hx.classNameAdd(t, 'datePicker_active');
    }


    /**
     * Schliesst das DatePicker-Overlay
     */
    static close(){
        if(document.getElementById("calendar_" + this.aktCal)){
            document.getElementById("calendar_" + this.aktCal).style.display = "none";
            var act = hx.objByCssSelector("#calendar" + this.fieldname + " .datePicker_active")[0];
            if(act) hx.classNameRemove(act, "datePicker_active");

            this.hxformfield.getFieldObj(this.fieldname).focus();

            this.aktCal = undefined;
            this.fieldname = undefined;
        }
    }

    /**
     * fuellt und zeigt das DatePicker-Overlay an
     * @param {string} fieldname
     */
    static show(fieldname){
        if(this.aktMonat > 11){
            this.aktMonat = 0;
            this.aktJahr++;
        }else if(this.aktMonat < 0){
            this.aktMonat = 11;
            this.aktJahr--;
        }
        var nextMonat = this.aktMonat + 1;
        var nextJahr = this.aktJahr;
        if(nextMonat > 11){
            nextMonat = 0;
            nextJahr++;
        }else if(nextMonat < 0){
            nextMonat = 11;
            nextJahr--;
        }
        var html = "";
        html += "<span class='hx-fa-icon-container hx-fa-icon-on datePicker_close' onclick=\"HXFormFieldDatePicker.close(HXFormFieldDatePicker.aktCal);\"><i class='fa-solid fa-xmark'></i></span>";
        html += "<span class='hx-fa-icon-container hx-fa-icon-on datePicker_shiftleft' onmousedown=\"HXFormFieldDatePicker.shift(-1,'click');return false;\"><i class='fa-solid fa-caret-left'></i></span>";
        html += "<span class='hx-fa-icon-container hx-fa-icon-on datePicker_shifttoday' onmousedown=\"HXFormFieldDatePicker.shift(0,'click');return false;\"><i class='fa-solid fa-reflect-horizontal'></i></span>";
        html += "<span class='hx-fa-icon-container hx-fa-icon-on datePicker_shiftright' onmousedown=\"HXFormFieldDatePicker.shift(1,'click');return false;\"><i class='fa-solid fa-caret-right'></i></span>";
        html += "<div class='datePicker_month_container_head1'>";
        html += "" + this.dict[this.aktMonat] + " " + this.aktJahr;
        html += "</div>";
        html += "<div class='datePicker_month_container_head2'>";
        html += "" + this.dict[nextMonat] + " " + nextJahr;
        html += "</div>";
        html += "<div class='datePicker_month_container1'>";
        html += this.getMonthGrid(this.aktJahr, this.aktMonat);
        html += "</div>";
        html += "<div class='datePicker_month_container2'>";
        html += this.getMonthGrid(nextJahr, nextMonat);
        html += "</div>";
        this.aktCal = this.fieldname;
        var calendar = document.getElementById("calendar_" + this.fieldname);
        calendar.onblur = function(){
            HXFormFieldDatePicker.close();
        };
        calendar.onkeydown = (e) => {

            //HELLO CHATGPT
            var act = hx.objByCssSelector("#calendar_" + this.fieldname + " .datePicker_month_container1 .datePicker_active")[0];

            if(!act){
                act = hx.objByCssSelector("#calendar_" + this.fieldname + " .datePicker_month_container1 .datePicker_day_chosen")[0];
                if(!act){
                    act = hx.objByCssSelector("#calendar_" + this.fieldname + " .datePicker_month_container1 .datePicker_day")[0];
                }
                hx.classNameAdd(act, "datePicker_active");
                act = hx.objByCssSelector("#calendar_" + this.fieldname + " .datePicker_active")[0];
            }

            var obj;
            var index;
            var objs = hx.objByCssSelector("#calendar_" + this.fieldname + " .datePicker_month_container1 .datePicker_day");

            for(var i = 0; i < objs.length; i++){
                if(act === objs[i]){
                    obj = act;
                    index = i;
                    break;
                }
            }
            var move = 0;
            // leertaste
            if(hx.value_in(e.key,' ', 'Enter')){
                obj.onmousedown();
                // escape
            }else if(e.key == 'Escape'){
                HXFormFieldDatePicker.close(HXFormFieldDatePicker.aktCal);
            }else if(e.key == 'ArrowLeft'){
                move = -1;
            }else if(e.key == 'ArrowRight'){
                move = 1;
            }else if(e.key == 'ArrowUp'){
                move = -7;
            }else if(e.key == 'ArrowDown'){
                move = +7;
            }
            obj = objs[index + move];
            if(!obj){
                var direction = move / Math.abs(move);
                this.shift(direction);
                if(direction > 0){
                    obj = hx.objByCssSelector("#calendar_" + this.fieldname + " .datePicker_month_container1 .datePicker_day")[0];
                }else{
                    obj = hx.objByCssSelector("#calendar_" + this.fieldname + " .datePicker_month_container1 .datePicker_day");
                    obj = obj[obj.length - 1];
                }
            }


            if(obj){
                hx.classNameRemove(act, "datePicker_active");
                hx.classNameAdd(obj, "datePicker_active");

            }
            return false;
        };
        calendar.innerHTML = html;
        calendar.style.display = "block";

        var fieldOffset = this.offset(this.hxformfield.getFieldObj());

        calendar.style.left = fieldOffset.left + "px";

        if(this.getDatePickerPosition() == "above"){
            calendar.style.top = (fieldOffset.top - $(".datePicker").height() - 5) + "px";
        }else{
            calendar.style.top = (fieldOffset.top + 24) + "px";
        }

        document.getElementById("calendar_" + fieldname).focus();
    }

    /**
     * Erstellt einen Monatsraster
     * @param {string} year
     * @param {int} month
     * @returns {string} html string mit quellcode fuer ein monat
     */
    static getMonthGrid(year, month){
        this.chosen;
        // Erster des Monats
        var detailDate = new Date(year, month, 1, 0, 0, 0, 0);
        var html = "";
        var tage_count = 0;
        var erster_tag;
        var letzter_tag;
        for(var i = 12; i < 19; i++) html += "<div class='datePicker_gridelement_head datePicker_day_head'>" + this.dict[i] + "</div>";
        html += "<div class='datePicker_gridelement_head datePicker_kw_head'>" + this.dict[19] + "</div>";
        while(detailDate.getMonth() == month){
            detailDate.setDate(detailDate.getDate() + 1);
            tage_count++;
        }
        erster_tag = new Date(year, month, 1, 0, 0, 0, 0).getDay() - 1;
        letzter_tag = new Date(year, month, tage_count, 0, 0, 0, 0).getDay() - 1;
        if(erster_tag == -1) erster_tag = 6;
        if(letzter_tag == -1) letzter_tag = 6;
        var all_count = 0;
        // leere Wochentage auffuellen bis der 1. beginnt
        for(var i = 0; i < erster_tag; i++){
            if(i > 4){
                html += "<div class='datePicker_gridelement_day datePicker_day_empty datePicker_day_weekend'></div>";
            }else{
                html += "<div class='datePicker_gridelement_day datePicker_day_empty'></div>";
            }
            all_count++;
        }
        // vom 1. bis zum letzten Monatstag auffuellen, nach jedem Wochenende die KW anzeigen
        var today = new Date();
        for(var i = 1; i <= tage_count; i++){
            var addClass = "";
            var thisDay = new Date(year, month, i, 0, 0, 0, 0);
            // Vergangene Tage einfaerben
            if(thisDay < today){
                addClass = " datePicker_day_past ";
            }
            // Wochenenden markieren
            if(thisDay.getDay() == 6 || thisDay.getDay() == 0) addClass += " datePicker_day_weekend ";
            // Heute markieren
            if(i == today.getDate() && year == today.getFullYear() && month == today.getMonth()){
                addClass = " datePicker_day_today ";
            }

            // Gewaehlten Tag markieren
            if(this.chosen && i == this.chosen.getDate() && year == this.chosen.getFullYear() && month == this.chosen.getMonth()){
                addClass += " datePicker_day_chosen ";
            }
            html += "<div onmousedown=\"HXFormFieldDatePicker.chosen = new Date(" + year + "," + month + "," + i + ",0,0,0,0); HXFormFieldDatePicker.dateInsert('" + HXFormFieldDatePicker.fieldname + "'," + year + "," + month + "," + i + ",0,0);HXFormFieldDatePicker.clicked();HXFormFieldDatePicker.close();return false;\" class='datePicker_gridelement_day datePicker_day " + addClass + "'>" + i + "</div>";
            all_count++;
            if(all_count % 7 == 0) html += "<div class='datePicker_gridelement_day datePicker_kw'>" + hx.date2kw(thisDay.getTime()) + "</div>";
        }
        // letzte Woche mit leeren Wochentagen auffuellen falls Sonntag nicht der letzte Tag ist
        for(var i = letzter_tag; i <= 5; i++){
            if(i > 3){
                html += "<div class='datePicker_gridelement_day datePicker_day_empty datePicker_day_weekend'></div>";
            }else{
                html += "<div class='datePicker_gridelement_day datePicker_day_empty'></div>";
            }
            all_count++;
        }
        // Wenn Monat auf 5 Wochen verteilt ist
        if(all_count == 35){
            if(letzter_tag != 6) html += "<div class='datePicker_gridelement_day datePicker_kw'>" + hx.date2kw((new Date(year, month, tage_count, 0, 0, 0, 0)).getTime()) + "</div>";
            // Leere 6. Woche anzeigen
            for(var i = 1; i <= 7; i++){
                if(i > 5){
                    html += "<div class='datePicker_gridelement_day datePicker_day_empty datePicker_day_weekend'></div>";
                }else{
                    html += "<div class='datePicker_gridelement_day datePicker_day_empty'></div>";
                }
            }
            html += "<div class='datePicker_gridelement_day datePicker_kw'></div>";
            // Wenn Monat auf 6 Wochen verteilt ist
        }else if(all_count == 42){
            html += "<div class='datePicker_gridelement_day datePicker_kw'>" + hx.date2kw((new Date(year, month, tage_count, 0, 0, 0, 0)).getTime()) + "</div>";
        }
        return html;
    }

    /**
     * ruft beim Clicken die [fieldname]_onchange-Funktion aus
     */
    static clicked(){
        if (HXFormFieldDatePicker.hxformfield.getFieldObj()){
            var fn = window[this.fieldname + "_onchange"];
            if(typeof fn === "function") fn();
        }
    }

    /**
     * Aendert den Darstellungsbereich
     * @param {int} months
     * @param {string} eventname
     */
    static shift(months, eventname){
        if(months == 0){
            this.aktMonat = new Date().getMonth();
            this.aktJahr = new Date().getFullYear();
        }else{
            this.aktMonat += months;
        }

        this.show(this.aktCal);

        if(eventname == 'click'){
            var t = hx.objByCssSelector("#calendar_" + this.fieldname + " .datePicker_month_container1 .datePicker_day");
            if(t){
                hx.foreach(t, function(tobj){
                    hx.classNameRemove(tobj, 'datePicker_active');
                });

                var t2 = hx.objByCssSelector("#calendar_" + this.fieldname + " .datePicker_month_container1 .datePicker_day_chosen")[0];
                if(t2){
                    hx.classNameAdd(t2, 'datePicker_active');
                }else{
                    hx.classNameAdd(t[0], 'datePicker_active');
                }
            }
        }

    }

    /**
     * liefert das offset eines Elements
     * @param {object} elem
     * @returns {{top: number, left: number}}
     */
    static offset(elem){
        if(!elem) elem = this;
        var x = elem.offsetLeft;
        var y = elem.offsetTop;
        while(elem = elem.offsetParent){
            x += elem.offsetLeft;
            y += elem.offsetTop;
        }
        return {left:x, top:y};
    }

    /**
     * fuegt das gewaehlte Datum in das Datumsfeld / Zeitfeld ein
     * @param {string} fieldname
     * @param {int} year
     * @param {int} month
     * @param {int} day
     * @param {int} hour default = 0
     * @param {int} minute default = 0
     * @param {int} second default = 0
     */
    static dateInsert(fieldname, year, month, day, hour=0, minute=0, second=0){
        // Eintragen in Feld
        if(HXFormFieldDatePicker.hxformfield.fieldExists()){
            if(HXFormFieldDatePicker.formFieldType === "HXFormFieldDate"){
                HXFormFieldDatePicker.hxformfield.setValue(hx.formatDateTime(hx.dateSerial(year, month + 1, day)));
                HXFormFieldDatePicker.hxformfield.getFieldObj().dispatchEvent(new Event('change'));  // Event change ausloesen
            }else if(HXFormFieldDatePicker.formFieldType === "HXFormFieldDateTime"){
                HXFormFieldDatePicker.hxformfield.setValue(hx.formatDateTime(hx.dateSerial(year, month + 1, day)));
                HXFormFieldDatePicker.hxformfield.getFieldObj().dispatchEvent(new Event('change'));  // Event change ausloesen
                // Zeit wird nur gesetzt, wenn noch leer:
                if(String(HXFormFieldDatePicker.hxformfield.getValueTime()) === ''){
                    var time = HXFormFieldDatePicker.hxformfield.getDefaultTimeText();
                    if(time == null) time = hx.formatTime(new Date().getTime());
                    HXFormFieldDatePicker.hxformfield.setValueTime(time);
                }
            }
        }
    }

    /**
     * Liefert ein Datums-Objekt aus dem aktuellen Wert des Date / DateTime - Feldes
     * @return {date} js-date-Objekt
     */
    static getChosenDate(){
        var ret = null;
        ret = hx.text2date(HXFormFieldDatePicker.hxformfield.getValue());
        if (ret===null){
            return new Date();
        }else{
            return new Date(ret);
        }
    }


    /**
     * Liefert die Position f�r den DatePicker: under oder above
     * @return {string} above | under
     */
    static getDatePickerPosition(){

        var ret = HXFormFieldDatePicker.hxformfield.getDatePickerPosition();
        if (ret===null) ret = "under";
        return ret;
    }


}